import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "stars d-flex" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "text-gray-05 text-size-14 mt-1 ml-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInvalidFeedback = _resolveComponent("FormInvalidFeedback")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.starSrc1,
          height: "40",
          width: "40",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickStar(1)))
        }, null, 8, _hoisted_3),
        _createTextVNode(),
        _createElementVNode("img", {
          src: _ctx.starSrc2,
          height: "40",
          width: "40",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickStar(2)))
        }, null, 8, _hoisted_4),
        _createTextVNode(),
        _createElementVNode("img", {
          src: _ctx.starSrc3,
          height: "40",
          width: "40",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickStar(3)))
        }, null, 8, _hoisted_5),
        _createTextVNode(),
        _createElementVNode("img", {
          src: _ctx.starSrc4,
          height: "40",
          width: "40",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickStar(4)))
        }, null, 8, _hoisted_6),
        _createTextVNode(),
        _createElementVNode("img", {
          src: _ctx.starSrc5,
          height: "40",
          width: "40",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClickStar(5)))
        }, null, 8, _hoisted_7)
      ]),
      _createTextVNode(),
      (_ctx.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.value) + "点\n      ", 1))
        : _createCommentVNode("", true)
    ]),
    _createTextVNode(),
    _createVNode(_component_FormInvalidFeedback, {
      "validation-state": _ctx.validationState,
      state: false
    }, null, 8, ["validation-state"])
  ]))
}